<template>
  <div style="padding: 10px">
    <div class="search-pc" style="margin: 10px 0">
      <el-input v-model="search.accountName" placeholder="请输入角色名" style="width: 200px; margin-right: 10px"
                clearable @keyup.enter="load"></el-input>
      <el-button type="primary" @click="load">查询</el-button>
      <el-button type="warning" @click="queryVipUser">vip用户</el-button>
      <el-button @click="resetData">重置</el-button>
      <el-button type="info" @click="syncResource">库存同步</el-button>
    </div>

    <div class="search-mobile">
      <div class="search-inputs">
        <el-input v-model="search.accountName" placeholder="角色名" size="small" clearable
                  @keyup.enter="load"></el-input>
      </div>
      <div class="action-btns">
        <el-button type="primary" size="small" @click="load">查询</el-button>
        <el-button type="warning" size="small" @click="queryVipUser">vip用户</el-button>
        <el-button size="small" @click="resetData">重置</el-button>
        <el-button type="info" size="small" @click="syncResource">库存同步</el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="tableData" border stripe style="width: 100%" class="table-pc">
      <el-table-column prop="accountName" label="角色名" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.accountName }}<el-tag v-if="scope.row.vip" size="mini" type="warning" style="margin-left:4px">V{{ scope.row.vip }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="roleId" label="角色ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="legacyCountResource" label="库存残券" show-overflow-tooltip></el-table-column>
      <el-table-column prop="canSendCnt" label="可送残券" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sendLegacyCnt" label="已送残券" show-overflow-tooltip></el-table-column>
      <el-table-column prop="coin" label="咸鱼币" show-overflow-tooltip></el-table-column>
      <el-table-column prop="vip" label="VIP" width="80px" show-overflow-tooltip></el-table-column>
      <el-table-column prop="syncTime" label="同步时间" show-overflow-tooltip></el-table-column>
    </el-table>

<div class="table-mobile" v-loading="loading">
      <div class="card-item" v-for="item in tableData" :key="item.id">
        <div class="card-row">
          <span class="card-label">角色名：</span>
          <span class="card-value">{{ item.accountName }} <el-tag v-if="item.vip" size="mini" type="warning">V{{ item.vip }}</el-tag></span>
        </div>
        <div class="card-row">
          <span class="card-label">库存残券：</span>
          <span class="card-value">{{ item.legacyCountResource || 0 }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">可送残券：</span>
          <span class="card-value">{{ item.canSendCnt || 0 }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">已送残券：</span>
          <span class="card-value">{{ item.sendLegacyCnt || 0 }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">咸鱼币：</span>
          <span class="card-value">{{ item.coin }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">同步时间：</span>
          <span class="card-value">{{ item.syncTime }}</span>
        </div>
      </div>
    </div>

    <div class="pagination-wrapper">
      <el-pagination class="pagination-pc" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      <el-pagination class="pagination-mobile" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'LegacyResource',
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      search: { accountName: '', vipMin: null }
    }
  },
created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      let params = { current: this.currentPage, size: this.pageSize };
      if (this.search.accountName) {
        params.accountName = this.search.accountName;
      }
      if (this.search.vipMin !== null && this.search.vipMin !== undefined) {
        params.vipMin = this.search.vipMin;
      }
      request.get("/legacySold/sortedByResource", {
        params: params
      }).then(res => {
        this.loading = false;
        if (res.code === '0') {
          let data = res.data;
          if (data && data.records) {
            this.tableData = data.records;
            this.total = data.total || 0;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('网络错误');
        this.tableData = [];
        this.total = 0;
      });
    },
    syncResource() {
      this.loading = true;
      request.get("/xyzwws/websocket/legacyResourceSync").then(res => {
        this.loading = false;
        if (res.code === '0') {
          this.$message({ type: "success", message: res.msg || "库存同步请求发送成功" });
        } else {
          this.$message({ type: "error", message: res.msg || "库存同步请求发送失败" });
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error("网络错误，库存同步请求失败");
      });
    },
    queryVipUser() {
      this.search.vipMin = 3;
      this.currentPage = 1;
      this.load();
    },
    resetData() {
      this.search = { accountName: '', vipMin: null };
      this.currentPage = 1;
      this.load();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    }
  }
}
</script>

<style scoped>
.search-mobile, .table-mobile, .pagination-mobile { display: none; }
.search-mobile .search-inputs { display: flex; gap: 10px; margin-bottom: 10px; }
.search-mobile .action-btns { display: flex; gap: 10px; }
.card-item { background: #fff; border: 1px solid #ebeef5; border-radius: 4px; padding: 12px; margin-bottom: 10px; }
.card-row { display: flex; align-items: center; padding: 5px 0; font-size: 14px; }
.card-label { color: #909399; width: 80px; flex-shrink: 0; }
.card-value { color: #303133; flex: 1; }

@media screen and (max-width: 768px) {
  .search-pc, .table-pc, .pagination-pc { display: none !important; }
  .search-mobile, .table-mobile, .pagination-mobile { display: block !important; }
  .card-item { background: #2a2a2a; border: 1px solid #3a3a3a; }
  .card-label { color: #909399; }
  .card-value { color: #e6a23c; }
}
</style>
